import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import axios from 'axios';
import axiosInstance from "../../../axios/axiosInstance";

const { Option } = Select;

export default function DoctorsSelect({ value, onChange }) {
  const [partners, setPartners] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState(null);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axiosInstance.get('/partners');
        setPartners(response.data.data);
      } catch (error) {
        console.error('Error fetching partners:', error);
      }
    };

    fetchPartners();
  }, []);

  useEffect(() => {
    // Устанавливаем значение выбранного партнера при инициализации
    if (value && partners.length > 0) {
      const selected = partners.find(partner => partner.id === value);
      setSelectedPartner(selected ? selected.id : null);
    }
  }, [value, partners]);

  const handlePartnerChange = (selectedValue) => {
    setSelectedPartner(selectedValue);
    onChange(selectedValue);
  };

  return (
      <Select
          id='doctors'
          className='text-sm h-10'
          value={selectedPartner}
          onChange={handlePartnerChange}
          placeholder="Ким юборди"
          allowClear
      >
        {partners.map(partner => (
            <Option key={partner.id} value={partner.id}>{partner.name}</Option>
        ))}
      </Select>
  );
}
